







































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

import { ParamApiEditar } from '@/pantallas/Conecta/BajasCobranza/models/BajasCobranza.models';

import { fetchMS } from '@/pantallas/Conecta/BajasCobranza/fetchMS';
import Confirmation from '@/components/Confirmation.vue';

@Component({ components: { DatePicker, Confirmation } })
export default class BajasCobranzaEditar extends Vue {
  @Prop({ required: true, default: {} }) data!: any;
  @Prop({ required: true, default: false }) statusFinished!: boolean;

  dialog: boolean = true;
  tabs: number = 0;
  paramApi: ParamApiEditar = {};
  disabledBtn: boolean = false;
  dialogConfirmation: boolean = false;
  confrmationData: {
    title?: string;
    msg?: string;
    action?: 'edit' | 'close';
    btnAceptar?: string;
    btnCancelar?: string;
  } = {};
  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  async mounted() {
    if (this.statusFinished) {
      this.$snotify.warning(
        `La baja de cobranza ${this.data.nombre_baja_cobranza} ya se encuentra finalizada y no se puede editar`,
        { timeout: 10000 }
      );
    }
    await this.initialValues();
  }

  initialValues() {
    const {
      cantidad_epc,
      descripcion,
      observaciones,
      nombre_tramo_baja_temporal,
      nombre_tramo_baja_definitiva,
      fecha_recuperacion_cliente,
      fecha_ingreso_baja_definitiva,
      fecha_ingreso_baja_temporal,
    } = this.data;

    this.paramApi = {
      cantidad_epc: cantidad_epc || '0',
      descripcion,
      observaciones,
      nombre_tramo_baja_temporal,
      nombre_tramo_baja_definitiva,
      fecha_recuperacion_cliente: moment(fecha_recuperacion_cliente) || '',
      fecha_ingreso_baja_definitiva:
        moment(fecha_ingreso_baja_definitiva) || '',
      fecha_ingreso_baja_temporal: moment(fecha_ingreso_baja_temporal) || '',
    };
  }

  rules = {
    cantidad_epc: (value: string) => {
      const valueInt: number = Number(value);
      if (valueInt < 0 || valueInt > 9999999) {
        return this.handleRules(
          'Solo se permiten números positivos iguales o menores a 9999999'
        );
      }
      return this.handleRules();
    },
    observaciones: (value: string) => {
      if (value && value.length > 150) {
        return this.handleRules('Solo se permite un máximo de 150 caracteres');
      }
      return this.handleRules();
    },
    nombre_tramo_baja_temporal: (value: string) => {
      if (value && value.length > 150) {
        return this.handleRules('Solo se permite un máximo de 150 caracteres');
      }
      return this.handleRules();
    },
    nombre_tramo_baja_definitiva: (value: string) => {
      if (value && value.length > 150) {
        return this.handleRules('Solo se permite un máximo de 150 caracteres');
      }
      return this.handleRules();
    },
    descripcion: (value: string) => {
      if (value && value.length > 300) {
        return this.handleRules('Solo se permite un máximo de 300 caracteres');
      }
      return this.handleRules();
    },
  };

  handleConfirmation(confitmation: boolean) {
    if (confitmation) {
      if (this.confrmationData.action === 'edit') this.put();
      if (this.confrmationData.action === 'close') this.close();
    }
    this.confrmationData = {};
    this.dialogConfirmation = false;
  }

  msgCongitmation(action: 'edit' | 'close') {
    if (action === 'edit') {
      this.confrmationData = {
        title: 'Editar Cobranza',
        msg: `¿Estás seguro de que deseas editar la baja de cobranza ${this.data.nombre_baja_cobranza}?`,
        btnAceptar: 'Editar',
        btnCancelar: 'Cancelar',
      };
    }
    if (action === 'close') {
      this.confrmationData = {
        title: 'Confirmación',
        msg:
          'Al cerrar esta ventana toda la información editada se perderá ¿Está seguro que desea cerrar sin guardar?',
        btnAceptar: 'Aceptar',
        btnCancelar: 'Cancelar',
      };
    }
    this.confrmationData.action = action;
    this.dialogConfirmation = true;
  }

  handleRules(msgError: string = '') {
    if (msgError) {
      this.disabledBtn = true;
      return msgError;
    }
    this.disabledBtn = false;
    return true;
  }

  handleEdit() {
    const cantidadEpcInt = Number(this.paramApi.cantidad_epc);
    if (cantidadEpcInt < 0 || cantidadEpcInt > 9999999) return;
    if (this.paramApi.observaciones && this.paramApi.observaciones.length > 150)
      return;
    if (
      this.paramApi.nombre_tramo_baja_temporal &&
      this.paramApi.nombre_tramo_baja_temporal.length > 150
    )
      return;
    if (
      this.paramApi.nombre_tramo_baja_definitiva &&
      this.paramApi.nombre_tramo_baja_definitiva.length > 150
    )
      return;
    if (this.paramApi.descripcion && this.paramApi.descripcion.length > 350)
      return;
    this.msgCongitmation('edit');
    this.dialogConfirmation = true;
  }

  handleClose() {
    this.msgCongitmation('close');
  }

  close(clean: boolean = false): void {
    this.$emit('cerrar', clean);
  }

  async put() {
    this.paramApi.cantidad_epc = this.paramApi.cantidad_epc || '0';
    const body = {
      user: localStorage.getItem('clienteDefecto'),
      user_id: JSON.parse(localStorage.getItem('user')).id,
      id: this.data.id,
      nombre_baja_cobranza: this.data.nombre_baja_cobranza,
      ...this.paramApi,
    };

    try {
      this.loadingService.showLoading();
      const result = await fetchMS({ endpoint: 'put', body });
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, MENSAJE_API } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);

      if (cod !== 1) {
        return this.$snotify.error(MENSAJE_RESPUESTA);
      }

      if (MENSAJE_API) {
        this.$snotify.warning(MENSAJE_RESPUESTA, { timeout: 10000 });
      } else {
        this.$snotify.success(MENSAJE_RESPUESTA);
      }
      this.close(true);
    } catch (error) {
      console.error(error instanceof Error ? error.message : error);
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor reintente un poco más tarde',
        { timeout: 3500 }
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }
}
